import { createInstance } from 'i18next'
import { initReactI18next } from 'react-i18next'
import { matchPath } from 'react-router-dom'

export const DEFAULT_LANG = 'en'

export function createI18n(pathname: string, data: Record<string, any>) {
  const i18nInstance = createInstance()
  const normalizedData = normalizeResources(data)
  const langs = Object.keys(normalizedData)

  i18nInstance
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: normalizedData,
      lng: getStartLang(langs, pathname),
      lowerCaseLng: true,

      keySeparator: false, // we do not use keys in form messages.welcome

      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    })
  return i18nInstance
}

export function normalizeResources(data: Record<string, any>) {
  return Object.fromEntries(
    Object.entries(data).map(([lang, translations]) => [
      lang.toLowerCase(),
      translations,
    ])
  )
}

export function getLangFromParam(langs: string[], langParam: string) {
  const normalizedLangs = langs.map((lang) => lang.toLowerCase())
  const langParamLower = langParam.toLowerCase()
  // Lang is on of configure...
  if (normalizedLangs.includes(langParamLower)) {
    return langParamLower
  }
  // Fallback 2 default one
  return DEFAULT_LANG
}

export function getStartLang(langs: string[], pathname: string) {
  const langMatch = matchPath('/:lang/*', pathname)
  if (langMatch) {
    return getLangFromParam(langs, langMatch.params.lang ?? '')
  }
  return DEFAULT_LANG
}
